/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Personal_TrainingInputs */

const en_service_type_personal_training = /** @type {(inputs: Service_Type_Personal_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal training`)
};

const pl_service_type_personal_training = /** @type {(inputs: Service_Type_Personal_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening personalny`)
};

/**
* | output |
* | --- |
* | "Personal training" |
*
* @param {Service_Type_Personal_TrainingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_personal_training = /** @type {((inputs?: Service_Type_Personal_TrainingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Personal_TrainingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_personal_training(inputs)
	return en_service_type_personal_training(inputs)
});